var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopTrends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 5H32.5V10M31.6667 5.83374C31.6667 5.83374 25 14.1671 7.5 20.0004M32.5008 35H30.8341C29.9136 35 29.1675 34.2538 29.1675 33.3333V16.6667C29.1675 15.7462 29.9136 15 30.8341 15H32.5008C33.4213 15 34.1675 15.7462 34.1675 16.6667V33.3333C34.1675 34.2538 33.4213 35 32.5008 35ZM20.8333 35.0004H19.1667C18.2462 35.0004 17.5 34.2542 17.5 33.3337V22.5004C17.5 21.5799 18.2462 20.8337 19.1667 20.8337H20.8333C21.7538 20.8337 22.5 21.5799 22.5 22.5004V33.3337C22.5 34.2542 21.7538 35.0004 20.8333 35.0004ZM9.16585 35H7.49919C6.57872 35 5.83252 34.2538 5.83252 33.3333V26.6667C5.83252 25.7462 6.57872 25 7.49919 25H9.16585C10.0863 25 10.8325 25.7462 10.8325 26.6667V33.3333C10.8325 34.2538 10.0863 35 9.16585 35Z",
    stroke: "url(#paint0_linear_1693_5079)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1693_5079",
    x1: 34.0005,
    y1: 5,
    x2: 6.00049,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#068AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A332EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopTrends);
export default __webpack_public_path__ + "static/media/top_trends.ee4145f9730f0d4bd94634a630d63734.svg";
export { ForwardRef as ReactComponent };